module.exports = __webpack_public_path__ + "static/media/helicopter.a19b295f.svg";